import { render, staticRenderFns } from "./BaseKbd.vue?vue&type=template&id=528453f5&scoped=true&"
import script from "./BaseKbd.vue?vue&type=script&lang=ts&"
export * from "./BaseKbd.vue?vue&type=script&lang=ts&"
import style0 from "./BaseKbd.vue?vue&type=style&index=0&id=528453f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528453f5",
  null
  
)

export default component.exports